import React from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carousel.css";
import { PrevArrow } from "./PrevArrow";
import { NextArrow } from "./NextArrow";
import { Button } from "../Button";
import { ILinkFunc } from "../../lib/util";


export enum ECarouselLinkPosition {
  bottom = "bottom",
  slide = "slide",
  overlay = "overlay",
}

export enum ECarouselTitlePosition {
  top = "top",
  overlay = "overlay",
}

export interface ICarouselProps {
  title?: string;
  titlePosition?: ECarouselTitlePosition;
  className?: string;
  slickSettings?: Settings;
  link?: string;
  linkLabel?: string;
  linkFunc?: ILinkFunc;
  linkPosition?: ECarouselLinkPosition;
  staticOverlayChildren?: React.ReactNode;
  sliderRef?: React.LegacyRef<Slider>;
}

export const Carousel: React.FC<ICarouselProps> = ({
  title,
  titlePosition = ECarouselTitlePosition.top,
  className,
  slickSettings = {},
  link,
  linkLabel = "View All",
  linkFunc,
  linkPosition = ECarouselLinkPosition.bottom,
  staticOverlayChildren,
  children,
  sliderRef,
}) => {
  const slickSettingVariant: Settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
    ...slickSettings,
  };

  const titleClasses =
    titlePosition == ECarouselTitlePosition.overlay
      ? "absolute top-0 left-0 right-0 z-10 py-[5%] text-white bg-gradient-to-b from-black/80 via-black/40 to-transparent flex flex-col gap-10"
      : "max-w-screen-xl w-full mx-auto";

  const linkf = linkFunc || ((props) => <a {...props} />);

  return (
    <div className={`listing-carousel relative ${className} flex flex-col`}>
      {title && (
        <h2 className={titleClasses}>
          {title && title + " "}
          {link && linkPosition == ECarouselLinkPosition.overlay && (
            <Button
              linkProps={{
                className: "hidden sm:inline-flex self-center",
                href: link
              }}
              linkFunc={linkf}
            >
              {linkLabel}
            </Button>
          )}
        </h2>
      )}

      <Slider
        ref={sliderRef}
        prevArrow={<PrevArrow />}
        nextArrow={<NextArrow />}
        {...slickSettingVariant}
      >
        {children}
        {link && linkPosition == ECarouselLinkPosition.slide && (
          <Button
            linkProps={{
              className: "aspect-[3/2] flex justify-center text-button-text bg-button-bg sm:outline outline-1 outline-white outline-offset-[-25px] hover:bg-action hover:text-action-text",
              href: link
            }}
            linkFunc={linkf}
          >
            {linkLabel}
          </Button>
        )}
      </Slider>
      {link && linkPosition == ECarouselLinkPosition.bottom && (
        <Button
          linkProps={{
            className: "px-3 py-2 self-center",
            href: link
          }}
          linkFunc={linkf}
        >
          {linkLabel}
        </Button>
      )}
      {staticOverlayChildren && <>{staticOverlayChildren}</>}
    </div>
  );
};
